import { render, staticRenderFns } from "./WhyAskingTCModal.vue?vue&type=template&id=021fb8ee"
import script from "./WhyAskingTCModal.vue?vue&type=script&lang=js"
export * from "./WhyAskingTCModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports